import styled from 'styled-components';

export const FileInputRoot = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: ${(props) =>
    props.isDisabled ? 'white' : props.isBeingHovered ? '#e2e8f0' : 'white'};
  color: #8898aa;
  padding: 2rem;
  border-radius: 4px;
  border: 1px dashed #ccc;
  font-size: 14px;
  transition: background-color 0.3s ease;
  cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
  text-align: center;
  &:hover {
    background-color: ${(props) => (props.isDisabled ? 'white' : '#f9f9f9')};
  }

  &:active {
    background-color: ${(props) => (props.isDisabled ? 'white' : '#f0f0f0')};
  }
`;
